import { render, staticRenderFns } from "./Minimize.vue?vue&type=template&id=84d61812&"
import script from "./Minimize.vue?vue&type=script&lang=js&"
export * from "./Minimize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports